import { Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { IWebsiteUrl } from 'src/app/core/dtos/interfaces/i-website-url';

@Component({
  selector: 'app-internal-information',
  templateUrl: './internal-information.component.html',
  styleUrls: ['./internal-information.component.scss'],
})
export class InternalInformationComponent {
  @Input() urls: IWebsiteUrl[];
  @Input() contentId: string;
  @Input() isExpandedByDefault = true;
  @Input() isExpandable = true;
}
